export const setDoctor = ({data,empty} : any) => ({
    type: "SET_DOCTOR",
    payload: {data,empty} ,
  });